import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let ExtendsTest = class ExtendsTest extends Vue {
    name = '111';
};
ExtendsTest = __decorate([
    Component({
        name: 'extendsTest',
    })
], ExtendsTest);
export default ExtendsTest;
